import { success_manager} from './success_manager';
import { failed_manager } from './failed_manager';
import { session_manager } from './sesson_expired';
import * as UserActions from './../actions/user_actions';
import * as FacilitiesActions from './../actions/facilities_actions';
export var response_Manager = (isNetworkError, dispatch,
    endpoint, payload, response, error, endpointurl) => {
     
      if(response && response.status === 203){
        return session_manager(dispatch, endpointurl,
            payload, response, error);
      }
      /* autoLogOut time is updated on every api response*/
      let autoLogOutSetting = JSON.parse(localStorage.getItem("autoLogOut"));
      if(autoLogOutSetting){
        let autoLogutSetting = {} , d1 = new Date (),  d2 = new Date ( d1 ),
        backendSessionLogoutTime = +autoLogOutSetting.autoLogOutTimeer;
        d2.setMinutes ( d1.getMinutes() + backendSessionLogoutTime );
        autoLogutSetting.autoLogOutTimeer = backendSessionLogoutTime;
        autoLogutSetting.autoLogOutTime = d2;
        if (window.localStorage){

        localStorage.setItem('autoLogOut', JSON.stringify(autoLogutSetting));
        }else {
         window.autoLogOutTime = autoLogutSetting;
        }

      }
      
    if (!response) {
        return failed_manager(dispatch, endpointurl,
            payload, response, error);
    } else if (response && response.status  ===  200) {
        return success_manager(dispatch, endpointurl, payload, response, endpoint);
    } else if (response.status != 200) {
        return failed_manager(dispatch, endpointurl,
            payload, response, error, endpoint);
    }
    return failed_manager(dispatch, endpoint,
        payload, response, response || error);
};



/** WEBPACK FOOTER **
 ** ./src/base/api_manager.js
 **/